export const container = ({ width }) => ({
    minHeight: '37.5rem',
    width,
    position: 'relative',

    tablet: {
        paddingLeft: '6.25rem',
    },

    tabletLarge: {
        minHeight: '50.8125rem',
    },
});

export const imagesContainer = ({ isLast }) => ({
    display: 'inline-flex',
    position: 'absolute',
    flexDirection: 'column-reverse',
    right: 0,

    width: isLast ? '100%' : 'unset',
    height: isLast ? '100%' : 'unset',

    tablet: {
        flexDirection: 'initial',
        position: 'relative',
        top: '2.5rem',
    },

    tabletLarge: {
        position: 'absolute',
        right: 0,
        top: 'unset',
        marginTop: '4rem',
    },
});
